var map = {
	".": 44,
	"./": 44,
	"./GraphQLLanguageService": 118,
	"./GraphQLLanguageService.js": 118,
	"./GraphQLLanguageService.js.flow": 451,
	"./autocompleteUtils": 77,
	"./autocompleteUtils.js": 77,
	"./autocompleteUtils.js.flow": 452,
	"./getAutocompleteSuggestions": 78,
	"./getAutocompleteSuggestions.js": 78,
	"./getAutocompleteSuggestions.js.flow": 453,
	"./getDefinition": 79,
	"./getDefinition.js": 79,
	"./getDefinition.js.flow": 454,
	"./getDiagnostics": 81,
	"./getDiagnostics.js": 81,
	"./getDiagnostics.js.flow": 455,
	"./getOutline": 117,
	"./getOutline.js": 117,
	"./getOutline.js.flow": 456,
	"./index": 44,
	"./index.js": 44,
	"./index.js.flow": 457
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 224;


//////////////////
// WEBPACK FOOTER
// ./node_modules/graphql-language-service-interface/dist ^.*$
// module id = 224
// module chunks = 0 1